export class User {
  public id: number;
  public username: string;
  public login: string;
  public password: string;
  public rememberMe: boolean;
  public session_id: string;
  public partner_id: number;

  public constructor(init?: Partial<User>) {
    Object.assign(this, init);
  }

  toJSON(): any {
    return {
      id: this.id,
      username: this.username,
      login: this.login,
      password: this.password,
      rememberMe: this.rememberMe,
      session_id: this.session_id,
      partner_id: this.partner_id,
    };
  }
}
